$(".js-scroll-to-signal-list").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".js-signal-list").offset().top
    }, 1000);
});

var timer = null;

if($(".js-signal-list").length > 0) {
  $(window).on("scroll", function(){
    if(timer !== null) {
        clearTimeout(timer);
    }
    timer = setTimeout(function() {
      if(
        $(this).scrollTop() > $(".js-signal-list").offset().top - $(window).height() &&
        $(this).scrollTop() < $(".js-signal-list").offset().top + $('.js-signal-list').outerHeight()
      ) {
        window.snowplow('trackStructEvent', 'signal', 'scrolled-to', 'signal-list');
      }
    }, 150);
  });
}
